module.exports = __webpack_public_path__ + "img/Korean_Local_Cards.e85458b4.png";